







































import AutocompleteUser from '@/components/inputs/AutocompleteUser.vue'
import UserChip from '@/components/inputs/UserChip.vue'
import {findUser, FindUserResp} from '@/data/repos/authUserSearch'
import {defineComponent, Ref, ref, watch} from '@vue/composition-api'
import {getUser} from '@/data/repos/authUser'

async function autocompleteFunction(q: string): Promise<FindUserResp[]> {
  if (q.length < 2) {
    return []
  }
  const r = await findUser(q)
  if (r) {
    return r.slice(0, 15)
  }
  return []
}

async function retrieveUserDetails(selected: number[], selectedUsers: Ref<FindUserResp[]>) {
  selectedUsers.value = await Promise.all(selected.map(async (id: number) => {
    return await getUser(id) as FindUserResp
  }))
}

export default defineComponent({
  props: {
    selected: {type: Array, default: () => []},
  },
  components: {UserChip, AutocompleteUser},
  setup(props, context) {
    let searchString = ref("")
    let selectedUsers = ref([] as FindUserResp[])
    let showAutocomplete = ref(false)
    let focused = ref(false)
    retrieveUserDetails(props.selected as number[], selectedUsers) // retrieve details for already selected users to show as UserChips
    watch(() => selectedUsers.value, (v) => {
      context.emit('update:selected', v.map((e: FindUserResp) => {
        return e.id // set selected prop to an array of selected user IDs
      }))
    }, {deep: true})
    watch(() => focused.value, (focused) => {
      if (focused) {
        showAutocomplete.value = true
      } else {
        setTimeout(() => showAutocomplete.value = false, 500)
      }
    }, {deep: true})
    const addUser = (user: FindUserResp) => {
      showAutocomplete.value = false
      if (props.selected.indexOf(user.id) == -1) {
        selectedUsers.value.push(user)
      }
      searchString.value = ""
    }
    const removeUser = (user: FindUserResp) => {
      selectedUsers.value = selectedUsers.value.filter((el) => {
        if (el.id !== user.id) {
          return el
        }
      })
    }
    const inputId = 'mu-select-' + String(Math.floor((Math.random() * 100000)))
    return ({
      searchString,
      autocompleteFunction,
      selectedUsers,
      showAutocomplete,
      focused,
      inputId,
      addUser,
      removeUser,
    })
  },
})
